<template>
  <div
    v-tooltip="eventTooltip"
    class="month-event"
    :class="{ 'a-tooltip': showImportedTimeOffBadge }"
    :aria-label="hrisImportedEventAriaLabel"
    :style="defaultStyle"
    :data-testid="showImportedTimeOffBadge ? 'schedules-time-off-event' : null"
  >
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column min-w-0">
        <div class="name d-flex align-items-center min-w-0">
          <span class="text-truncate">{{ userRealName }}</span>
        </div>
        <div class="event-details d-flex align-items-center min-w-0">
          <span class="text-truncate">{{ eventDetails }}</span>
          <TimeOffHrisImportedBadge
            v-if="showImportedTimeOffBadge"
            :integration-type="importedIntegrationType"
            class="ml-5"
          />
        </div>
      </div>

      <div
        v-if="shiftSpillover"
        class="d-flex align-items-center"
      >
        <i
          v-tooltip="{ placement: 'top' }"
          class="hi-right"
          title="This shift continues into the next day"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SchedulesEventMixin from '~/mixins/attendance_schedules/SchedulesEventMixin';
import TimeOffHrisImportedBadge from '~/components/time_off/TimeOffHrisImportedBadge.vue';
import tooltipDirective from '~/directives/tooltip';

// Rendered inside @fullcalendar/vue3's mini `createApp`, which doesn't inherit the host app's
// context — no `$page` (mapInertiaProps would crash) and no global directives. `timeZone` comes in
// as a prop from the host and the tooltip directive is registered locally.
export default {
  name: 'MonthViewEvent',
  components: { TimeOffHrisImportedBadge },
  directives: { tooltip: tooltipDirective },
  mixins: [SchedulesEventMixin],
  props: {
    event: {
      type: Object,
      required: true,
    },
    timeZone: {
      type: String,
      default: '',
    },
  },
  computed: {
    eventDetails() {
      return this.type !== 'Holiday' ? `${this.type}: ${this.duration}` : this.type;
    },
  },
};
</script>
